import styled from 'styled-components';

export const Anchor = styled.span`
  display: inline-flex;
`;
